import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import * as utils from "../../utils/components";
import { StyledScrollable } from "./Scrollable.styled";
var ScrollableBase = function (_a) {
    var _b = _a.vertical, vertical = _b === void 0 ? true : _b, _c = _a.horizontal, horizontal = _c === void 0 ? false : _c, children = _a.children;
    return (_jsx(StyledScrollable, { vertical: vertical, horizontal: horizontal, children: children }));
};
export var Scrollable = React.memo(ScrollableBase, utils.arePropsEqual);
